var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoStatusAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.736 6.039 4.554 7.969A2 2 0 0 1 14.554 17H5.446a2 2 0 0 1-1.736-2.992l4.554-7.97a2 2 0 0 1 3.472 0z",
    fill: "#EDBF1A"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    d: "M10 15v-3M10 9.8v-.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStatusAlert);
export default __webpack_public_path__ + "static/media/ico-status-alert.11f87bb5ca0086fc333f9eb4ca5d807a.svg";
export { ForwardRef as ReactComponent };